<div class="Flexbox__flex-1">
  <!--  <div class="results-pane-subheader">Normal / Germline - Specimen Info</div>-->
  <gen-editable-parameter [isEditableField]="!disabledForced" [title]="'Specimen ID:'" [value]="sample.identifiers[0]"
                          [invalid]="identifiers.dirty && identifiers.invalid"
                          [required]="true"
                          [ngClass]="{'diff_marker':isInUpdatedFields('identifiers[0]')}"
  >
    <input deep-blur placeholder="Specimen ID"
           class="form-control fs6_5"
           type="text"
           required
           id="identifiers-input{{index}}"
           [pattern]="'^([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])?[._-])*([A-Za-z0-9]+)$'"
           #identifiers="ngModel"
           (ngModelChange)="tumorChanged = identifiers.valid"
           (focus)="previousValue = sample.identifiers[0]"
           (blur)="tumorChanged?modelChange($event,sample,'identifiers[0]',true):resetValue(identifiers.name)"
           [(ngModel)]="sample.identifiers[0]"
           name="identifiers[0]"/></gen-editable-parameter>
  <gen-editable-parameter [invalid]="!sample.type" [required]="true"
                          [isEditableField]="allowedit" [title]="'Specimen type:'"
                          [value]="sample.type ? sample.type.display :'Required information missing'"
                          [ngClass]="{'diff_marker':isInUpdatedFields('type')}"
  >
    <select deep-blur [(ngModel)]="sample.type" class="form-control fs6_5"
            [compareWith]="compareBy" id="specimenType-input{{index}}" required name="specimenType{{index}}"
            (change)="modelChange($event,sample,'type',true);">
      <option [ngValue]="null">- Not Selected -</option>
      <option *ngFor="let st of collectionsData.specimenTypes; trackBy: trackByFn" [ngValue]="st">{{st.display}}</option>
    </select>
  </gen-editable-parameter>
  <gen-editable-parameter [isEditableField]="allowedit" [title]="'Collection method:'"
                          [value]="sample.collection.method ? sample.collection.method.display :''"
                          [ngClass]="{'diff_marker':isInUpdatedFields('collection.method')}"
  >
    <select deep-blur [(ngModel)]="sample.collection.method" class="form-control fs6_5" [compareWith]="compareBy"
            id="specimenCollection-input{{index}}" (change)="modelChange($event,sample,'collection.method',false);">
      <option [ngValue]="null">- Not Selected -</option>
      <option *ngFor="let cm of collectionsData.specimenCollections; trackBy: trackByFn" [ngValue]="cm">{{cm.display}}
      </option>
    </select>
  </gen-editable-parameter>
  <gen-editable-parameter [isEditableField]="!disabledForced" [title]="'Specimen Collection Date:'"
                          [value]="sample.collection.collectedDateTime | date:'dd MMM yyyy'"
                          [ngClass]="{'diff_marker':isInUpdatedFields('collection.collectedDateTime')}"
  >
    <p-calendar tabindex="-1" deep-blur id="specimenCollectedDateTime-input{{index}}"
                icon="icon__Calendar"
                panelStyleClass="hide-month-nav"
                showButtonBar="true" [inputStyleClass]="'form-control Auto_Specimen_Collection_Date_Input'"
                [(ngModel)]="sample.collection.collectedDateTime"
                [showIcon]="true" dateFormat="dd M yy"
                dataType="string"
                placeholder="Select date (e.g: 08 Feb 1974)"
                (onSelect)="setTime(sample.collection.collectedDateTime);onDateSelect(sample,'collection.collectedDateTime')"
                (onFocus)="onFocus($event)" [monthNavigator]="true"
                [yearNavigator]="true" yearRange="1900:2100">
    </p-calendar>
  </gen-editable-parameter>
</div>
<div class="Flexbox__flex-1 Spacebox__l-small">
  <!--  <div class="Flexbox results-pane-subheader">Normal / Germline - Sample Info</div>-->
  <gen-editable-parameter [isEditableField]="false" [title]="'ID / Lab Accession #:'"
                          [value]="sample.accessionIdentifier.value">
  </gen-editable-parameter>
  <gen-editable-parameter [isEditableField]="allowedit" [title]="'Sample Received Date:'"
                          [value]="sample.receivedTime | date:'dd MMM yyyy'"
                          (clickOutside)="allowedit && onDateSelect(sample,'receivedTime');"
                          [attachOutsideOnClick]="true"
                          [excludeBeforeClick]="true"
                          [exclude]="'.p-datepicker-trigger,.p-datepicker'"
                          [ngClass]="{'diff_marker':isInUpdatedFields('receivedTime')}"
  >
    <p-calendar tabindex="-1" deep-blur id="specimenReceivedTime-input{{index}}"
                icon="icon__Calendar"
                panelStyleClass="hide-month-nav"
                showButtonBar="true" [inputStyleClass]="'form-control Auto_Sample_Received_Date_Input'"
                [(ngModel)]="sample.receivedTime"
                placeholder="Select date (e.g: 08 Feb 1974)"
                dataType="string"
                [showIcon]="true" dateFormat="dd M yy"
                (onSelect)="setTime(sample.receivedTime)"
                (onFocus)="onFocus($event)" [monthNavigator]="true"
                [yearNavigator]="true" yearRange="1900:2100">
    </p-calendar>
  </gen-editable-parameter>
  <gen-editable-parameter id="specimenBatchId-input{{index}}" *ngIf='!!sample.batchId' [isEditableField]="false"
                          [title]="'Batch ID:'" [value]="sample.batchId"></gen-editable-parameter>
  <gen-editable-parameter id="specimenReagentCartridgeId-input{{index}}" *ngIf='!!sample.reagentCartridgeId'
                          [isEditableField]="false" [title]="'Reagent Cartridge ID:'"
                          [value]="sample.reagentCartridgeId"></gen-editable-parameter>
</div>

